<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-alert class="mb-0" v-if="error" tile type="error">{{ error }}</v-alert>
                <v-card-title class="primary white--text">{{ formTitle }}</v-card-title>
                <v-card-text class="pt-4">
                    <v-form ref="form">
                        <v-row>
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                    <v-expansion-panel-header disable-icon-rotate>
                                        <template v-slot:default="{ open }">
                                            <v-row no-gutters>
                                                <v-col cols="4">Company</v-col>
                                                <v-col cols="8" class="text--secondary">
                                                    <v-fade-transition leave-absolute>
                                                        <span v-if="open" key="0"></span>
                                                        <span v-else key="1">{{ editedItem.name }}</span>
                                                    </v-fade-transition>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="editedItem.name"
                                                    :counter="50"
                                                    :rules="[rules.required, rules.maxLength(50)]"
                                                    label="Name*"
                                                    outlined
                                                    class="subtitle-2"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="editedItem.description"
                                                    :counter="500"
                                                    label="Description"
                                                    outlined
                                                    class="subtitle-2"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>

                                <v-expansion-panel>
                                    <v-expansion-panel-header disable-icon-rotate>
                                        <div>
                                            Address
                                            <span class="font-italic grey--text">Optional</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="editedItem.address1"
                                                    :counter="200"
                                                    :rules="[rules.maxLength(200)]"
                                                    label="Address 1"
                                                    outlined
                                                    class="subtitle-2"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="editedItem.address2"
                                                    :counter="200"
                                                    :rules="[rules.maxLength(200)]"
                                                    label="Address 2"
                                                    outlined
                                                    class="subtitle-2"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="editedItem.zipCode"
                                                    :counter="10"
                                                    :rules="[rules.maxLength(10)]"
                                                    label="Zip Code"
                                                    outlined
                                                    class="subtitle-2"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="editedItem.city"
                                                    :counter="100"
                                                    :rules="[rules.maxLength(100)]"
                                                    label="City"
                                                    outlined
                                                    class="subtitle-2"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-autocomplete
                                                    v-model="editedItem.country"
                                                    :items="countries"
                                                    item-text="name"
                                                    item-value="code"
                                                    label="Select Country"
                                                    class="subtitle-2"
                                                    outlined
                                                    
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="close">Cancel</v-btn>
                    <v-btn outlined rounded :loading="isSaving" color="primary" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import helper from "@/utils/helper.js";
import * as countries from "@/utils/countries.js";

export default {
    name: "customer-edit-dialog",
    props: ["dialog", "object"],
    data() {
        return {
            error: null,
            isSaving: false,
            panel: 0,
            editedItem: {
                id: "",
                name: "",
                description: "",
                address1: "",
                address2: "",
                zipCode: "",
                city: "",
                country: ""
            },
            defaultItem: {
                id: "",
                name: "",
                description: "",
                address1: "",
                address2: "",
                zipCode: "",
                city: "",
                country: ""
            },
            countries: countries,
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                minLength: len => v =>
                    (v || "").length >= len ||
                    `Invalid character length, required ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long"
            }
        };
    },
    computed: {
        formTitle() {
            return this.object ? "Edit Customer" : "New Customer";
        }
    },
    watch: {
        // reset form when dialog open or close
        dialog() {
            this.resetForm();
        }
    },
    methods: {
        resetForm() {
            // reset form state
            this.error = null;
            this.isSaving = false;
            this.panel = 0;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            // when editing, set form with object
            if (this.dialog && this.object) {
                this.editedItem.id = this.object.id;
                this.editedItem.name = this.object.name;
                this.editedItem.description = this.object.description;
                this.editedItem.address1 = this.object.address1;
                this.editedItem.address2 = this.object.address2;
                this.editedItem.zipCode = this.object.zipCode;
                this.editedItem.city = this.object.city;
                this.editedItem.country = this.object.country;
            }
            // when new or closing, set form with default
            else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
        },

        close() {
            this.$emit("update:dialog", false);
            this.resetForm();
        },

        save() {
            if (!this.$refs.form.validate()) {
                return;
            }

            // set form state
            this.error = null;
            this.isSaving = true;

            // prepare api call payload
            var payload = {
                name: this.editedItem.name,
                description: this.editedItem.description,
                address1: this.editedItem.address1,
                address2: this.editedItem.address2,
                zipCode: this.editedItem.zipCode,
                city: this.editedItem.city,
                country: this.editedItem.country
            };

            // if editing
            if (this.object) {
                // prepare graphql mutation payload
                payload.id = this.editedItem.id;

                // update
                this.$store
                    .dispatch("customers/updateCustomer", payload)
                    .then(response => {
                        // update parent object
                        this.$emit("update:object", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors[0].message;
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
            // new
            else {
                this.$store
                    .dispatch("customers/createCustomer", payload)
                    .then(response => {
                        this.$emit("item-created", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors
                            .map(error => error.message)
                            .join(", ");
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>